import React from 'react';
import { underscored } from 'underscore.string';

const resourcesExplained = [
    {
        title: 'Introduction',
        description: 'Read about the Clever Tykes co-founders.',
        image: require('../assets/images/icons/ct-bulb-square.jpg'),
        className: 'feature color-1',
        iconClass: 'icon v2',
        permalink: '/intro.pdf'
    },
    {
        title: 'Enterprise education',
        description: 'Why it’s so important that enterprise education improves.',
        image: require('../assets/images/icons/pdf-icon.png'),
        className: 'feature color-2',
        iconClass: 'icon',
        permalink: 'http://clevertykes.com/primary-enterprise-education/'
    },
    {
        title: 'Feedback',
        description: 'Tell us how your pupils have enjoyed the books.',
        image: require('../assets/images/icons/light-bulb-1.png'),
        className: 'feature color-3 bottom',
        iconClass: 'icon',
        permalink: 'https://goo.gl/forms/2HWhan6oN6AOCNv02'
    },
    {
        title: 'Our sponsor',
        description: 'A message from our sponsor, Lloyds Banking Group.',
        image: require('../assets/images/icons/shake-square.jpg'),
        className: 'feature color-4 bottom',
        iconClass: 'icon v2',
        permalink: 'https://api.clevertykes.com/sponsor-letter'
    }
];

const ResourcesExplained = () => (
    <div>
        <div className="index-1">
            <div className="section-name index-1">
                <h1 id="more-resources">More about our resources</h1>
                <p>Hover over each icon below to learn more</p>
                <div className="sep" />
            </div>
        </div>
        <div className="features-wrapper index-1">
            <div className="container">
                <div className="features row">
                    {resourcesExplained.map((item, index) => (
                        <div className="feature-outer col-sm-6 col-lg-3 col-md-6 col-xs-12" key={index} id={underscored(item.title)}>
                            <a href={item.permalink} className={item.className}>
                                <div className={item.iconClass}>
                                    <img src={item.image} alt={item.title} className="img-responsive" />
                                </div>
                                <h2>{item.title}</h2>
                                <p>{item.description}</p>
                            </a>
                        </div>
                    ))}

                </div>
            </div>
        </div>
    </div>
);

export default ResourcesExplained;



/** WEBPACK FOOTER **
 ** ./src/components/ResourcesExplained.js
 **/